// extracted by mini-css-extract-plugin
export default {"top_sec":"style_top_sec__LWPC2","item":"style_item__ZXR8b"};